import { SwitchCase } from "components/DesignSystem/SwitchCase/SwitchCase";
import { TakeConfirmationModal } from "components/TakeConfirmationModal/TakeConfirmationModal";
import { STEPS } from "constants/qboImportSteps";
import { ModalControl } from "hooks/useModal";
import { FinallyAddDetailsStep } from "./FinallyAddDetailsStep";
import { FinallyMapCategoriesStep } from "./FinallyMapCategoriesStep";
import { FinallyMapDataConnectionsStep } from "./FinallyMapDataConnectionsStep";
import { FinallyReviewStep } from "./FinallyReviewStep";
import {
  ImportFinallyProvider,
  useImportFinally,
} from "./ImportFinallyContext";

type ImportFinallyProps = {
  entityId: string;
  resumeImportProcessId: string | null;
} & ModalControl;

const ImportFinallySteps = () => {
  const { currentStep, importProcessId } = useImportFinally();

  return (
    <SwitchCase
      value={currentStep}
      cases={{
        [STEPS.ADD_DETAILS]: <FinallyAddDetailsStep />,
        [STEPS.MAP_DATA_CONNECTIONS]: importProcessId && (
          <FinallyMapDataConnectionsStep importProcessId={importProcessId} />
        ),
        [STEPS.MAP_CATEGORIES]: importProcessId && (
          <FinallyMapCategoriesStep importProcessId={importProcessId} />
        ),
        [STEPS.REVIEW]: importProcessId && (
          <FinallyReviewStep importProcessId={importProcessId} />
        ),
      }}
    />
  );
};

export const ImportFinally = ({
  entityId,
  resumeImportProcessId,
  isOpen,
  close,
  showConfirmation,
  dismissConfirmation,
}: ImportFinallyProps) => (
  <>
    <ImportFinallyProvider
      entityId={entityId}
      resumeImportProcessId={resumeImportProcessId}
      isOpen={isOpen}
      close={close}
    >
      <ImportFinallySteps />
    </ImportFinallyProvider>
    <TakeConfirmationModal
      isOpen={showConfirmation}
      dismiss={dismissConfirmation}
      close={close}
    />
  </>
);
